<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <div
      v-if="
        elections &&
          (!allElectionsVoted ||
            (allElectionsVoted &&
              $store.state &&
              $store.state.electionEvent &&
              $store.state.electionEvent.Rewritable))
      "
      class="md-layout"
    >
      <div class="md-layout">
        <div
          class="md-layout-item title-alert"
          v-if="
            $store.state &&
              $store.state.electionEvent &&
              $store.state.electionEvent.Rewritable
          "
        >
          <!-- <md-icon class="md-size-1x space2">warning</md-icon> -->
          <span class="revotealert"
            >{{ $t("election-list.revote-alert") }}
          </span>
        </div>

        <div
          v-for="(column, index) in elections"
          :key="column[0].ElectionIdentifier.Id + index"
          class="md-layout-item"
        >
          <md-card
            v-for="election in column"
            :key="election.ElectionIdentifier.Id"
            class=" grid-w"
            v-bind:class="{ disabled:  (!$store.state.electionEvent.Rewritable && (election.Status === 'VOTED' || election.Status === 'NOT_VOTED') || (election.Status === 'DISABLED')), 
            blocked: election.Status === 'SIGNED' }"
          >
          <!-- ICONE -->
            <div class="md-small-hide">
              <md-icon class="icon-election md-size-2x" v-if="election.Status === 'VOTED'|| election.Status === 'NOT_VOTED'">ballot</md-icon>
              <md-icon :class="election.Status === 'DISABLED' ? '' : 'icon-election'" class="md-size-2x" v-if="election.Status === 'TO_VOTE' || election.Status === 'DISABLED'"> how_to_vote</md-icon>
              <md-icon class="icon-election md-size-2x" v-if="election.Status === 'SIGNED'" style="color:#c7052b !important">warning_amber</md-icon>
            </div>

            <div role="heading" aria-level="3" class="card-title "
              ><span class="screenreader"
                >{{ $t("election-list.ballot-paper") }}:
              </span>
              <div>{{ election.ElectionIdentifier.ElectionName }}</div>
              <div  v-if="(election.Status === 'VOTED' || election.Status === 'NOT_VOTED') && $store.state.electionEvent.Rewritable" class="voted">
                  {{ $t("election-list.election-status.voted-or-not-voted") }}
                </div>
            </div>

              <div class="md-layout-item md-size-20 md-small-size-100 info-election"> 
                <div> {{ $t("election.preferences.candidates.election-type") }}: {{election.ChoiceType == 'CANDIDATES' ? $t("election.candidates-label") : $t("election.affiliations-label")}}</div>
                <div v-if="election.ChoiceType == 'CANDIDATES'"> {{ $t("election.preferences.candidates.max-number") }}: {{election.MaxVotes}}</div>
                <div v-if="election.ChoiceType == 'AFFILIATIONS'"> {{ $t("election.preferences.affiliations.max-number") }}: {{election.MaxVotes}}</div>
              </div>
              <div
                class="md-layout-item md-size-15  md-small-size-100 space2 buttons"
                v-if="
                  election.Status !== 'SIGNED' && election.Status !== 'DISABLED'" >

              <md-button
                  @click="
                    electionsToVote[election.ElectionIdentifier.Id] = true;
                    clicked();
                  "
                  class="md-raised   vote-btn"
                  v-bind:class="
                    election.Status === 'TO_VOTE' ? 'md-primary' : 'md-primary'
                  "
                  v-if="
                    election.Status === 'TO_VOTE' ||
                      (election.Status !== 'TO_VOTE' &&
                        $store.state &&
                        $store.state.electionEvent &&
                        $store.state.electionEvent.Rewritable)
                  "
                  :id="'vote' + election.ElectionIdentifier.Id"
                  :disabled="disable"
                  :aria-disabled="disable"
                  :aria-label="
                    $t('election-list.vote-button-tooltip') +
                      election.ElectionIdentifier.ElectionName
                  "
                >
                  <md-tooltip
                    v-bind:style="isMobile ? 'display: none;' : ''"
                    class="tooltip"
                    >{{ $t("election-list.vote-button-tooltip") }}</md-tooltip
                  >{{ $t("election-list.vote-button") }}
                </md-button>

                <md-button
                  @click="
                    electionsToAbst[election.ElectionIdentifier.Id] = true;
                    clicked();
                  "
                  v-if="
                    (election.Status === 'TO_VOTE' ||
                      (election.Status !== 'TO_VOTE' &&
                        $store.state &&
                        $store.state.electionEvent &&
                        $store.state.electionEvent.Rewritable)) &&
                      $store.state &&
                      $store.state.electionEvent &&
                      $store.state.electionEvent.AbstentionMode != 'DISABLED'
                  "
                  class="md-raised  md-accent abst-btn"
                  :id="'abst' + election.ElectionIdentifier.Id"
                  :disabled="disable"
                  :aria-label="
                    $t('election-list.abstention-label') +
                      election.ElectionIdentifier.ElectionName
                  "
                  :aria-disabled="disable"
                  ><md-tooltip
                    v-bind:style="isMobile ? 'display: none;' : ''"
                    class="tooltip"
                    >{{
                      $t("election-list.abstention-button-tooltip")
                    }}</md-tooltip
                  >
                  {{ $t("election-list.abstention-button") }}
                </md-button>


                <div
                  v-if="
                    (election.Status === 'VOTED' ||
                      election.Status === 'NOT_VOTED') && !$store.state.electionEvent.Rewritable
                  "
                  style="color:var(--pcolor)"
                >
                 <b>{{ $t("election-list.election-status.voted-or-not-voted") }}</b> 
                </div>
              </div>
              <div
                class="md-layout-item md-size-15  md-small-size-100"
                v-if="election.Status === 'SIGNED'"
                style="padding: 20px 0;">

                <span style="color:#c7052b;">
                  {{ $t("election-list.election-status.signed") }}
                </span>
              </div>
              <div
                class="md-layout-item md-size-15  md-small-size-100"
                style="padding: 20px 0;"
                v-if="election.Status === 'DISABLED'"
              >
                {{ $t("election-list.election-status.disabled") }}.
              </div>
              <abstention-dialog
                :confirmAbstention="
                  electionsToAbst[election.ElectionIdentifier.Id]
                "
                @cancel="
                  closeElection(election.ElectionIdentifier.Id, 'noDialog');
                  confirmAbstention = false;
                  closeAbstentionOrVote = true;
                  !isMobile ? utils.removeModalHandler() : '';
                  scroll();
                "
                @abstention="
                  confirmAbstention = false;
                  abstAndReload(election.ElectionIdentifier.Id);
                  !isMobile ? utils.removeModalHandler() : '';
                "
                @opened="
                  reactivate();
                  noScroll();
                  !isMobile ? utils.modalOpened('#abstention-dialog') : '';
                "
              >
              </abstention-dialog>
              <md-dialog
                role="dialog"
                :aria-modal="electionsToVote[election.ElectionIdentifier.Id]"
                class="box-ww full-screen-dialog"
                :md-fullscreen="false"
                :md-active.sync="
                  electionsToVote[election.ElectionIdentifier.Id]
                "
                :no-close-on-esc="false"
                :md-click-outside-to-close="false"
                @md-cancel="closeElection(election.ElectionIdentifier.Id)"
                @md-opened="
                  noScroll();
                  !isMobile ? utils.modalOpened('#election-modal') : '';
                "
                @md-closed="
                  !isMobile ? utils.removeModalHandler() : '';
                  scroll();
                  setActualTab(null);
                "
                @keydown.tab="
                  utils.handleTabNavigation($event, contestLevels ? '#election-modalx' : '#one-contest-level', actualTab, '#electionVoteButtons', '#close-button')
                "
                id="election-modal"
                :md-backdrop="false"
              >
                <div class="md-layout header-light-w" id="election-title">
                  <div class="md-layout-item md-size-100">
                    <div
                      class="md-caption title"
                      v-if="
                        $store.state &&
                          $store.state.electionEvent &&
                          $store.state.electionEvent.ElectionEvent
                      "
                      role="heading"
                      aria-level="1"
                    >
                      <span class="screenreader"
                        >{{ $t("election-event-title") }}:
                      </span>
                      {{
                        $store.state.electionEvent.ElectionEvent.EventIdentifier
                          .EventName
                      }}
                    </div>

                    <div
                      class="md-title title-second"
                      role="heading"
                      aria-level="2"
                    >
                      <span class="screenreader"
                        >{{ $t("election-list.ballot-paper") }}:
                      </span>
                      {{ election.ElectionIdentifier.ElectionName }}
                    </div>
                  </div>

                  <div class="md-layout-item" id="close-button">
                    <md-button
                      @click="
                        closeElection(
                          election.ElectionIdentifier.Id,
                          'noDialog'
                        );
                        reactivate();
                        closeAbstentionOrVote = true;
                      "
                      id="close-election-button"
                      class="md-icon-button close-button"
                      :disabled="!closeButton"
                      :aria-disabled="!closeButton"
                      :aria-label="$t('election-list.close-button-tooltip')"
                      tabindex="0"
                    >
                      <md-tooltip
                        v-bind:style="isMobile ? 'display: none;' : ''"
                        class="tooltip"
                        >{{ $t("election-list.close-button") }}
                      </md-tooltip>
                      <md-icon
                        class="md-size-1x"
                        aria-hidden="true"
                        role="presentation"
                        >close</md-icon
                      >
                    </md-button>
                  </div>
                </div>
                <election
                  v-if="!isMobile"
                  :electionId="election.ElectionIdentifier.Id"
                  @actualTab="setActualTab"
                  @moreLevels="getContestLevels"
                  @progressbar-loaded="closeButton = true"
                  @scheda-urna="reactivate()"
                  @closeElection="closeElection"
                  
                >
                </election>
                <election-mobile
                  v-if="isMobile"
                  :electionId="election.ElectionIdentifier.Id"
                  @progressbar-loaded="closeButton = true"
                  @scheda-urna="reactivate()"
                  @closeElection="closeElection"
                >
                </election-mobile>
              </md-dialog>
          </md-card>
        </div>
      </div>
    </div>

    <div
      class="md-layout"
      v-if="
        elections &&
          allElectionsVoted &&
          $store.state &&
          $store.state.electionEvent &&
          !$store.state.electionEvent.Rewritable
      "
    >
      <div class="md-title md-layout-item md-size-100 schededisp">
        {{ $t("election-list.thanks") }}
      </div>
      <div class="md-layout">
        <md-button
          @click="backToList()"
          class="md-button logout md-accent"
          v-if="this.$store.state.eventNumber > 1"
          role="navigation"
          :aria-label="$t('election-list.back-to-events')"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
          >
            {{ $t("election-list.back-to-events") }}
          </md-tooltip>
          {{ $t("election-list.back-to-events") }}
        </md-button>

        <md-button @click="logout()" class="md-button logout md-accent">
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("election-list.logout-button-tooltip") }}
          </md-tooltip>
          <md-icon class="md-size-1x icon-accent" aria-hidden="true" role="presentation"
            >exit_to_app</md-icon
          >
          {{ $t("election-list.logout-button") }}
        </md-button>
      </div>
    </div>

    <confirm-logout-dialog
      :confirmLogout="confirmLogout"
      @cancel="confirmLogout = false"
      @oklogout="logout()"
      @opened="
        noScroll();
        !isMobile ? utils.modalOpened('#logout-dialog') : '';
      "
      @closed="
        !isMobile ? utils.removeModalHandler() : '';
        scroll();
      "
    >
    </confirm-logout-dialog>
    <md-dialog
      role="dialog"
      id="schedavotata"
      :md-fullscreen="false"
      :md-active.sync="voteConfirmed"
      class="dialog-icon"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      @keydown.tab="utils.handleTabNavigation($event, null, null, '#schedavotata', null)"
      @md-opened="
        noScroll();
        !isMobile ? utils.modalOpened('#schedavotata') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        scroll();
      "
    >
      <md-dialog-title class="abs-title" role="heading" aria-level="1">{{
        $t("election-list.vote-done-dialog.title")
      }}</md-dialog-title>

      <div class="space md-layout">
        <span class="material-icons" aria-hidden="true"> done </span
        >{{ $t("election-list.vote-done-dialog.content-text") }}<br />
      </div>
      <md-dialog-actions>
        <md-button
          @click="
            voteConfirmed = false;
            closeAbstentionOrVote = true;
          "
          id="chiudiconfermavoto"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="chiudiconftooltip"
            >{{ $t("election-list.close-button") }}
          </md-tooltip>
          {{ $t("election-list.close-button") }}</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <div id="confirmAbstentionModal">
      <md-dialog
        role="dialog"
        :aria-modal="abstentionConfirmed"
        id="astensione-espressa"
        :md-fullscreen="false"
        :md-active.sync="abstentionConfirmed"
        :no-close-on-esc="false"
        :md-click-outside-to-close="false"
        @keydown.tab="utils.handleTabNavigation($event, null, null, '#astensione-espressa', null)"
        @md-opened="
          noScroll();
          !isMobile ? utils.modalOpened('#astensione-espressa') : '';
        "
        @md-closed="
          reactivate();
          !isMobile ? utils.removeModalHandler() : '';
          scroll();
        "
      >
        <md-dialog-title class="abs-title">{{$t("election-list.abstention-dialog.title")}}</md-dialog-title>
        <span class="space md-layout"  style="justify-content: center;"
          >{{ $t("election-list.abstention-dialog.content-text") }}<br
        /></span>
        <md-dialog-actions>
          <md-button
            @click="
              abstentionConfirmed = false;
              closeAbstentionOrVote = true;
            "
            id="confermaAstensione"
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="chiudiconftooltip"
              >{{ $t("election-list.close-button") }}
            </md-tooltip>
            {{ $t("election-list.close-button") }}</md-button
          >
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import Election from "./Election";
import ElectionMobile from "./ElectionMobile";
import { isMobile } from "mobile-device-detect";
import AbstentionDialog from "./AbstentionDialog";
import ConfirmLogoutDialog from "./ConfirmLogoutDialog";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
    this.getElections();
    document.getElementById("skip").focus();

    /* this.listOrCandidates = // CANDIDATES / AFFILIATIONS
      election.Election[0].ElectionVotingContest.ChoiceType; */
  },
  data: function() {
    return {
      elections: null,
      orderedElections: {},
      electionsToVote: {},
      electionsToAbst: {},
      confirmClosingSession: false,
      voteConfirmed: false,
      confirmAbstention: false,
      abstentionConfirmed: false,
      confirmLogout: false,
      disable: false,
      click: false,
      loaded: false,
      isMobile: false,
      closeButton: false,
      lastFocus: "",
      lastAbstentionOrVoteFocus: "",
      clickAbstentionOrVote: false,
      closeAbstentionOrVote: false,
      handler: {},
      utils: null,
      showInfo: false,
      contacts: "",
      actualTab: null,
      contestLevels: false
    };
  },
  props: [],
  methods: {
    noScroll() {
      document.documentElement.style.overflow = "hidden";
      document.getElementById("app").setAttribute("aria-hidden", "true");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => (x.tabIndex = "-1"));
      document.getElementById("logout").tabIndex = "-1";
      this.lastFocus = document.activeElement;
    },
    scroll() {
      document.documentElement.style.overflow = "auto";
      document.getElementById("app").setAttribute("aria-hidden", "false");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => x.removeAttribute("tabindex"));
      document.getElementById("logout").removeAttribute("tabindex");

      this.lastFocus.focus();

      //Astensione -> Annulla || Vota -> Chiudi scheda elettorale
      if (this.clickAbstentionOrVote) {
        if (this.closeAbstentionOrVote) {
          this.lastAbstentionOrVoteFocus.focus();
          this.clickAbstentionOrVote = false;
          this.closeAbstentionOrVote = false;
        }
      }
    },
    async closeElection(electionId, noDialog) {
      this.electionsToVote[electionId] = false;
      await this.getElections();
      this.$nextTick(() => {
        this.$forceUpdate();
        if (noDialog != "noDialog") this.voteConfirmed = true;
      });
    },
    async abstAndReload(electionId) {
      await this.makeAbstention(electionId);
      await this.getElections();
      this.$forceUpdate();
    },
    async getElections() {
      let elections = await this.$store.state.ceoCbbService.getElectionsList(
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0],
        this.$store.state.voterIdentification.EventIdentifier.Id
      );

      if (elections.error) {
        //console.error(elections.error);
        alert(elections.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }

      this.elections = this.orderElections(
        elections,
        this.$store.state.electionEvent.VotingPresentation.NumColumns
      );

      for (let i = 0; i < elections.BallotStatus.length; i++) {
        this.electionsToVote[
          elections.BallotStatus[i].ElectionIdentifier.Id
        ] = false;
        this.electionsToAbst[
          elections.BallotStatus[i].ElectionIdentifier.Id
        ] = false;
      }
      this.$forceUpdate();
      this.loaded = true;
      this.$emit("electionsListRetrieved");
    },
    async logout() {
      if (this.$store.state.logoutUrl) {
        const url = this.$store.state.logoutUrl;
        this.$store.replaceState({});
        window.location.href = url;
      } else {
        this.$store.replaceState({});
        this.$keycloak.logoutFn();
      }
    },
    async closingVotingSession() {
      let closing = await this.$store.state.ceoCbbService.closingVotingSession(
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0],
        this.$store.state.voterIdentification.EventIdentifier.Id
      );

      if (closing.error) {
        //console.error(closing.error);
        alert(
          this.$i18n.t("error.close-voting-session") +
            this.$store.state.alertMessage
        );
      }
    },
    orderElections(elections, columns) {
      let ordered = elections.BallotStatus.sort((a, b) => {
        a.ElectionIdentifier.DisplayOrder > b.ElectionIdentifier.DisplayOrder
          ? 1
          : -1;
      });
      let orderedElections = {};
      for (let k = 0; k < ordered.length; k = k + columns) {
        for (let i = 0; i < columns; i++) {
          if (!orderedElections[i]) orderedElections[i] = [];
          if (ordered[k + i]) orderedElections[i].push(ordered[k + i]);
        }
      }
      return orderedElections;
    },
    async makeAbstention(electionId) {
      let abstention = await this.$store.state.ceoCbbService.makeAbstention(
        electionId,
        this.$store.state.electionEvent.ElectionEvent.EventIdentifier.Id,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );

      if (abstention.error) {
        alert(
          this.$i18n.t("error.send-abstention") + this.$store.state.alertMessage
        );
      } else {
        if (abstention.randomUsername) {
          // " Se Ceo ritorna randomUsername e pw vuol dire che esiste
          //già in CBB una scheda votat dall'elettore loggato, quindi invio
          // a cbb la richiesta di cancellazione";
          let result = await this.$store.state.ceoCbbService.ballotDelete(
            electionId,
            this.$store.state.electionEvent.ElectionEvent.EventIdentifier.Id,
            abstention.randomUsername,
            abstention.randomPassword
          );
          // Scheda cancellata
          if (result.Accepted == "yes") {
            this.openFinalConfirm = false;
            this.abstentionConfirmed = true;
          } else {
            alert(
              this.$i18n.t("error.send-abstention") +
                this.$store.state.alertMessage
            );
          }
        } else {
          this.abstentionConfirmed = true;
        }
      }
      this.$forceUpdate();
    },
    tryLogout() {
      if (this.allElectionsVoted) this.logout();
      else this.confirmLogout = true;
    },
    clicked() {
      //ASTENSIONE e VOTA -> disabilita bottoni in ElectionList
      this.click = true;
      this.disable = true;
      this.clickAbstentionOrVote = true;
      this.lastAbstentionOrVoteFocus = document.activeElement;
      this.$forceUpdate();
    },
    reactivate() {
      //cliccato 'Astieniti' e abilita 'Sì, prosegui' alla riapertura
      if (this.click) {
        this.disable = false;
        this.click = false;
        this.closeButton = false;
        this.$forceUpdate();
      }
    },
    backToList() {
      this.$emit("backToList");
    },
    setActualTab(evt) {
      this.actualTab = evt;
    },
    getContestLevels(evt) {
      this.contestLevels = evt;
    }
  },
  computed: {
    allElectionsVoted: function() {
      // booleano calcolato che informa se l'utente ha votato in tutte le elezioni
      // per cui aveva diritto.
      for (let column in this.elections) {
        for (let election in this.elections[0]) {
          //console.log(this.elections[0][election]);
          if (
            this.elections[0][election].Status === "TO_VOTE" ||
            this.elections[0][election].Status === "SIGNED" ||
            this.elections[0][election].Status === "DISABLED"
          )
            return false;
        }
      }

      if (
        this.$store.state &&
        this.$store.state.electionEvent &&
        !this.$store.state.electionEvent.Rewritable
      ) {
        this.closingVotingSession();
      }

      return true;
    }
  },
  components: {
    Election,
    ElectionMobile,
    AbstentionDialog,
    ConfirmLogoutDialog
  }
};
</script>
<style scoped>
.switch-container {
  position: relative;
  font-size: 12px;
  right: 0px;
  float: right;
  bottom: 0px;
}

.md-dialog.all {
  width: 30% !important;
  height: auto !important;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
}

.md-dialog {
  overflow: auto;
}
.md-dialog2 {
  width: 30%;
  height: auto;
  max-width: 30%;
  max-height: 40%;
}

.dialog-icon .material-icons {
  color: var(--pcolor);
  margin-right: 10px;
  margin-bottom: 15px;
  font-size: 50px;
  line-height: 21px;
  font-weight: bold;
}

.dialog-icon {
  font-size: 16px;
}

.md-dialog3 {
  width: 30%;
  height: 230px !important;
  max-width: 30%;
}
.space {
  margin: 10px;
}
.space2 {
  margin: 5px;
}
.custombutton {
  width: 150px !important;
}
.title {
  text-align: left;
}
.schededisp {
  padding: 20px;
  margin: 30px 0 20px 0;
}
.schededisptitle {
  font-size: 22px !important;
  font-weight: bold;
  text-transform: none;
  flex: 0 1 33.3%;
}
.revotealert {
  font-weight: bold;
  font-size: 70%;
}

@media screen and (max-width: 375px) {
  .revotealert {
    font-size: 80%;
  }
}

span.md-dialog-title {
  margin: 0;
  color: var(--pcolor) !important;
}

.md-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
  font-size: 18px !important;
  position: relative;
  z-index: 0;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
}

.md-card .md-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  background: #fff !important;
}

.header-light-w .btn-menu-w {
  position: absolute !important;
  right: 20px !important;
  top: 20px !important;
}

.imgsize {
  max-width: 30% !important;
}

.md-button.md-raised:not([disabled]) {
  /* box-shadow: none !important; */
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: var(--pcolor) !important;
  /* box-shadow: none !important; */
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: var(--pcolor) !important;
  color: #fff !important;
  /* box-shadow: none !important; */
}

.md-button.md-theme-default.md-raised:not([disabled]) {
  color: var(--pcolor) !important;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary[data-v-1b949507] {
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active {
  color: var(--pcolor) !important;
}

.md-tabs-indicator {
  background-color: var(--pcolor) !important;
  background-color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  );
}

.md-button.md-active {
  color: var(--pcolor) !important;
  color: var(--md-theme-default-primary-on-background, var(--pcolor));
}

.md-button {
  padding: 0 30px !important;
  margin: 0;
}

.voted {
  color: var(--pcolor) !important;
  font-weight: bold;
  font-size: 16px;
  margin-top: -5px;
}

.grid-w {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1.5px solid var(--pcolor);
  border-radius: 20px;
  margin: 20px 30px;
  padding: 20px;
  text-align: left;
}
.icon-election {
  width: 50px;
}

.info-election {
  color: var(--pcolor);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
}
.md-icon.md-theme-default.md-icon-font.icon-election {
  color: var(--pcolor);
}
.md-icon.md-theme-default.md-icon-font.icon-disabled {
  color: var(--md-theme-default-primary-on-background, #333) !important;
}

.buttons .md-button {
  width: 150px !important;
}
.card-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  color: #333;
  flex: 1 1 55%;
  min-width: 55%;
  max-width: 55%;
}
.md-card.md-layout-item.space.grid-www.md-theme-default {
  padding: 0 0 20px 0 !important;
}

.grid-www {
  margin: 0 !important;
}

.md-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  text-align: center;
  background: var(--pcolor);
  color: #fff !important;
  padding-bottom: 20px;
}

.md-button {
  border-radius: var(--brb);
}

.abs-title {
  text-transform: none !important;
  font-size: 20px;
  padding: 15px 15px 20px !important;
}

.md-caption {
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  background: var(--pcolor);
  color: #fff !important;
  padding-top: 0px;
}

.md-card-header.md-title {
  color: #333 !important;
  padding: 0 !important;
}

.md-layout.content-election-w {
  display: contents !important;
  width: 80%;
  margin: 0 auto !important;
  padding: 20px 0 50px 0;
  max-width: 80%;
  left: 0 !important;
  position: static !important;
}

.md-button {
  font-weight: bold;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
  color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  ) !important;
}

.title-alert .md-icon-font {
  margin-right: 5px;
}

.md-icon-font:hover {
  color: #333 !important;
  color: var(--md-theme-default-primary-on-background, #333) !important;
}

.md-fab .md-ripple,
.md-fab::before,
.md-icon-button .md-ripple,
.md-icon-button::before {
  border-radius: 0 !important;
  background: transparent !important;
}

.md-fab,
.md-icon-button {
  border-radius: 0 !important;
  z-index: 999885 !important;
}

.header-light-w {
  padding: 20px;
  background: var(--pcolor) !important;
  float: left !important;
  display: block !important;
}

.btn-align {
  text-align: center !important;
  padding-left: 0px !important;
}

.close-button {
  position: absolute;
  top: 0px !important;
  right: -10px !important;
  margin: 6px;
}

.md-button.md-icon-button.close-button:focus-visible {
  border: 2px solid #338fff;
  border-radius: 5px !important;
}

.title-second {
  line-height: 24px;
  padding-bottom: 0;
}

.title-alert {
  font-weight: bold;
  font-size: 24px;
  padding: 22px;
  background: #fff3cd;
  border-radius: var(--br);
  background-color: var(--pcolor);
  margin: 30px 30px 10px 30px;
  color: #fff;
  flex: 1 1 100%;
}

.md-caption.title {
  padding: 5px 10px;
  color: #fff !important;
}

.full-screen-dialog {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.logout {
  border: 1px solid #555;
  height: 40px;
  margin: 30px auto;
  background-color: #fff;
}

.md-raised.md-dense {
  font: 14px;
  font-weight: 600;
}

.md-card.disabled {
  background-color: #f7f7f7;
  border: 1.5px solid #bbb;
}

.md-card.blocked {
  background-color: #f7f7f7;
  border: 1.5px solid #c7052b;
}

.vote-btn {
  margin-bottom: 20px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
}

.md-button.md-theme-default.md-raised.vote-btn[disabled],
.md-button.md-theme-default.md-raised.abst-btn[disabled] {
  color: #0f0f0f;
}

.icon-accent {
  color: var(--pcolor) !important;
}

#chiudiconfermavoto {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
}

#confermaAstensione {
  color: var(--pcolor) !important;
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
}

@media screen and (max-width: 960px) {
  .card-title {
    flex: 1 1 100%;
    min-width: 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }

  .grid-w {
    display: block;
    text-align: center;
  }

  .buttons {
    margin: 20px 0 0 0;
  }

  .vote-btn {
    margin-bottom: 0px;
    margin-right: 20px;
  }

  .md-layout-item.md-small-size-100 {
    min-width: 15%;
  }
}
@media screen and (max-width: 1024px) {
  .md-layout-item.md-size-33 {
    min-width: 100% !important;
  }

  .dialog-icon .material-icons {
    margin: 0 auto;
    padding-bottom: 20px;
  }
}

@media screen and (max-width: 599px) {
  .md-card .md-title {
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
    background: #fff !important;
  }

  .xmd-title {
    font-size: 12px !important;
    letter-spacing: 0;
    line-height: 12px !important;
  }

  .header-light-w {
    flex: 0 !important;
  }

  .md-icon-button {
    border-radius: 0 !important;
    z-index: 9999999885 !important;
  }
  .all {
    max-height: 30vh !important;
  }
  .md-dialog.all {
    height: 230px !important;
  }

  .md-layout {
    flex: 1;
  }
  .title-alert {
    font-size: 18px;
  }

  .title-second {
    font-size: 14px;
    line-height: 18px;
    margin-top: 6px;
  }

  .imgsize {
    max-width: 80% !important;
  }

  .chiudiconftooltip {
    z-index: 20;
  }

  .dialog-icon .material-icons {
    font-size: 70px;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }

  .md-button + .md-button {
    margin-left: auto;
  }

  .vote-btn {
    margin-bottom: 20px;
    margin-right: 0px;
  }

  #confermaAstensione {
    color: var(--pcolor) !important;
    background-color: #fff !important;
    border: 1px solid var(--pcolor);
  }
}
</style>
